import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import footerBg from '../assets/images/footer-bg.png'
import footerImage from '../assets/images/footer.svg'

const FooterContainer = styled.div`
  display: flex;
`

const FooterColumn = styled.div`
  margin-top: 40px;
  background: url('${footerBg}');
  background-repeat: no-repeat;
  width: 100%;
`

const FooterLogoContainer = styled.div`
  img {
    display: block;
    margin: auto;
  }

  @media screen and (max-width: 1200px) {
    img {
      max-width: 80%;
    }
  }
`

const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 80px 20px;

  @media screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }

  @media print {
    bottom: 40px;
  }
`

const Footer = ({ projectName }) => (
  <FooterContainer>
    <FooterColumn>
      <FooterLogoContainer>
        <img src={footerImage} alt="Quantstamp" />
      </FooterLogoContainer>
      <TextContainer>
        <p>© {new Date().getFullYear()} – Quantstamp, Inc.</p>
        <p>{projectName}</p>
      </TextContainer>
    </FooterColumn>
  </FooterContainer>
)

Footer.defaultProps = {
  projectName: '',
}

Footer.propTypes = {
  projectName: PropTypes.string,
}

export default Footer
